var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fill":"#E1E1E1","d":"M4.377 3.999L1.758 6.617c-.072.072-.112.168-.112.271 0 .103.04.199.112.27l.23.23c.072.072.168.112.27.112.103 0 .2-.04.271-.112L5.647 4.27c.072-.072.112-.169.112-.271 0-.103-.04-.2-.112-.272L2.532.612C2.46.54 2.364.5 2.262.5c-.103 0-.2.04-.271.112l-.23.23c-.15.149-.15.392 0 .54L4.377 4z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0H7V7H0z","transform":"translate(7.20264 7.5) rotate(-180)"})))]);
}

Chevron.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = Chevron;

Chevron.default = Chevron;
